export const checkedCardTitle = (title) => ({ type: "CHECK_CARD_TITLE_STEP_ONE", payload: title });

export const checkedCardReducerStepOne = (state = "", action) => {
  switch (action.type) {
    case "CHECK_CARD_STEP_ONE":
      state = state === action.payload ? "" : action.payload;
      return state;
    default:
      return state;
  }
};

export const checkedCardTitleReducerStepOne = (state = "", action) => {
  switch (action.type) {
    case "CHECK_CARD_TITLE_STEP_ONE":
      state = state === action.payload ? "" : action.payload;
      return state;
    default:
      return state;
  }
};
